import http from "../js/axios";
class HospitalSerive {
  create(data) {
    return http.post("/userlogin/user_registration", data);
  }
  login(data) {
    return http.post("/userlogin/user_registration", data);
  }
  updateToken(data) {
    return http.post("/hospital/user_token", data);
  }
  changePassword(data) {
    return http.post("/userlogin/changepassword", data);
  }
  commonWaitingList(data) {
    return http.post("/userlogin/common_waitlist", data);
  }
  commonLiverWaitingList(data) {
    return http.post(
      "/recipient_registration/in_hospital_organ_commonwaiting_list",
      data
    );
  }
  fetchMasterZone() {
    return http.post("/userlogin/master_zone", {
      dml_indicator: "s",
    });
  }
  commonWaitingListUidSearch(data) {
    return http.post("/userlogin/common_uhid_search", data);
  }
  // Phase 2 - Waitlist OTP Access Control (#24)
  waitlistSendOTP(data) {
    return http.post("/userlogin/waitlist_send_otp", data);
  }
  waitlistVerifyOTP(data) {
    return http.post("/userlogin/waitlist_verify_otp", data);
  }
  forgot(data) {
    return http.post("/userlogin/forgetpasswordupdation", data);
  }
  userList(data) {
    return http.post("/userlogin/user_list", data);
  }
  createUser(data) {
    return http.post("/hospital/newusercreate", data);
  }
  deleteUser(data) {
    return http.post("/hospital/user_delete", data);
  }
  resendPassword(data) {
    return http.post("/userlogin/resentpassword", data);
  }
  get(id) {
    return http.post("/userlogin/user_edit", { hospital_contact_id: id });
  }
  refresh() {
    return http.post("userlogin/refresh_token", {
      dml_indicator: "RT",
    });
  }
}
export default new HospitalSerive();
